import { assignTokens } from '@sail/engine';
import { tokens } from '@sail/ui';
import { lightHelmColorTokens, whiteHelmColorTokens, darkHelmColorTokens, lightSailColorTokens, darkSailColorTokens, whiteSailColorTokens } from '../colorThemes';
import { flavors } from '../colorFlavors';
import { helmTokens } from './helmTokens';
import { capitalizeFirstLetter } from '../../lib/utils';
export const themeAssignedColorTokens = {
    lightHelm: assignTokens(helmTokens.color, lightHelmColorTokens),
    whiteHelm: assignTokens(helmTokens.color, whiteHelmColorTokens),
    darkHelm: assignTokens(helmTokens.color, darkHelmColorTokens),
    lightSail: assignTokens(tokens.color, lightSailColorTokens),
    darkSail: assignTokens(tokens.color, darkSailColorTokens),
    whiteSail: assignTokens(tokens.color, whiteSailColorTokens)
};
const generateAssignColorTokens = (tokensToBeAssigned, flavorTokens)=>{
    const result = {};
    // Base tokens
    if (flavorTokens.tokens) {
        result.tokens = assignTokens(tokensToBeAssigned, flavorTokens.tokens);
    }
    // Theme-specific tokens
    if (flavorTokens.themeTokens) {
        Object.entries(flavorTokens.themeTokens).forEach(([theme, tokens])=>{
            result[theme] = assignTokens(tokensToBeAssigned, tokens);
        });
    }
    // Accent tokens
    if (flavorTokens.accents) {
        Object.entries(flavorTokens.accents).forEach(([accent, accentTokens])=>{
            if (accentTokens.tokens) {
                result[accent] = assignTokens(tokensToBeAssigned, accentTokens.tokens);
            }
            if (accentTokens.themeTokens) {
                Object.entries(accentTokens.themeTokens).forEach(([theme, tokens])=>{
                    const key = `${accent}${capitalizeFirstLetter(theme)}`;
                    result[key] = assignTokens(tokensToBeAssigned, tokens);
                });
            }
        });
    }
    return result;
};
const isSailFlavor = (flavor)=>{
    return flavor.endsWith('Sail');
};
const generateFlavorAssignedColorTokens = (flavors)=>{
    const acc = {};
    Object.entries(flavors).forEach(([flavor, tokensToBeAssigned])=>{
        if (isSailFlavor(flavor)) {
            acc[flavor] = generateAssignColorTokens(tokens.color, tokensToBeAssigned);
        } else {
            acc[flavor] = generateAssignColorTokens(helmTokens.color, tokensToBeAssigned);
        }
    });
    return acc;
};
export const flavorsAssignedColorTokens = generateFlavorAssignedColorTokens(flavors);

//# sourceMappingURL=assignedColorTokens.js.map